// pages/EnergyLanding.jsx
import React from "react";
import HeroNavbarWithDrawer from "./HeroNavbarWithDrawer";
import HeroSection from "./HeroSection";

export default function EnergyLanding() {
  const [currentImageIndex, setCurrentImageIndex] = React.useState(0);
  const backgroundImages = ["/image/Background.png","/image/BG.png",  "/image/BG2.png"];

  React.useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prev) => (prev + 1) % backgroundImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div>
      <HeroNavbarWithDrawer />
      <HeroSection backgroundImages={backgroundImages} currentImageIndex={currentImageIndex} />
    </div>
  );
}
